
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/details/[id]",
      function () {
        return require("private-next-pages/products/details/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/details/[id]"])
      });
    }
  